module.exports = __webpack_public_path__ + "static/media/check-on.95a82e0e.svg";